import { createSlice } from "@reduxjs/toolkit";

type IdsState = {
  selectedDriver: string | null;
};

const initialState: IdsState = {
  selectedDriver: null,
};

const idsSlice = createSlice({
  name: "ids",
  initialState,
  reducers: {
    setSelectedDriver(state, action) {
      state.selectedDriver = action.payload;
    },
  },
});

export const { setSelectedDriver } = idsSlice.actions;

export default idsSlice.reducer;
